/** @format */

import {

    FETCH_OCCASION,
    SET_OCCASION,
    BUY_E_GIFT,

  
  } from "./actions.type";
  import ApiService from "@/common/api.services";
  
  const state = {
    occasions:[],
   
  };
  
  const getters = {
 
    occasions() {
      return state.occasions;
    },
  
 
  };
  
  const actions = {
 
    [FETCH_OCCASION]({ commit }) {
      state.isLoading = true;
      return ApiService.getWithParams("occasions")
        .then(({ data: { response: res } }) => {
          commit(SET_OCCASION, res);
          state.isLoading = false;
          return res;
        })
        .catch((error) => {
          state.isLoading = false;
          console.error(error);
          return error.response.status;
        });
    },
    [BUY_E_GIFT](context, params) {
      return ApiService.post('voucher/purchase', params)
        .then(response => {
          return response.data;
        })
        .catch(error => {
          return error.response.status;
        });
    },
  
   
  };
  
  const mutations = {
 
    [SET_OCCASION](state, res) {
      if (res.data.length) state.occasions = res.data;
      state.isLoading = false;
    },
 
    
  };
  
  export default {
    state,
    actions,
    mutations,
    getters,
  };
  